import React from 'react';
import withIcon from '../utilities/withIcon';

const IconEye = () => {
  return (
    <g>
      <path d="m8 4.43a3.57 3.57 0 1 0 3.57 3.57 3.574 3.574 0 0 0 -3.57-3.57zm0 5.74a2.17 2.17 0 1 1 2.1694-2.17 2.1715 2.1715 0 0 1 -2.1694 2.17z" />
      <path d="m15.7974 7.635c-.1174-.1914-2.919-4.6894-7.7974-4.6894s-7.68 4.498-7.7974 4.6894a.7.7 0 0 0 0 .7295c.1172.1914 2.919 4.69 7.7969 4.69s7.6807-4.4985 7.7978-4.69a.7.7 0 0 0 .0001-.7295zm-7.7974 4.0191c-3.3394 0-5.6167-2.6631-6.3491-3.6541.7324-.9914 3.0098-3.654 6.3491-3.654s5.6167 2.6626 6.3491 3.654c-.7324.991-3.0097 3.6541-6.3491 3.6541z" />
    </g>
  );
};

export default withIcon(IconEye);
